import React from "react";
import "../CongratulationsDialog/CongratulationsDialog.scss";

import { CircularProgress, Dialog, DialogContent, LinearProgress, linearProgressClasses, styled } from "@mui/material";
import { LightButton, PrimaryButton } from "../AllButtons/AllButtons";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { useNavigate } from "react-router-dom";
import { reviewAnswer } from "../../Slice/courseSlice";
import GraphIcon from "../../assets/images/vactor/success-check.svg";

const CongratulationsDialog = () => {
  const [open, setOpen] = React.useState(true);

  // Original UI styling - completely unchanged
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
      ...theme.applyStyles("dark", {
        backgroundColor: theme.palette.grey[800],
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: "#4F46E5",
      ...theme.applyStyles("dark", {
        backgroundColor: "#4F46E5",
      }),
    },
  }));

  // Dynamic calculation logic (only functional change)
  const totalScore = useAppSelector(state => state.course.testDetails?.total_score);
  const userName=useAppSelector(state=>state.user.user.name);
  const testDetails=useAppSelector(state=>state.course.testDetails);
  const dispatch=useAppDispatch();
  const [correct, total] = totalScore?.split('/').map(Number) || [0, 3];
  const percentage = Math.round((correct / total) * 100);
  const proficiency = percentage >= 80 ? "Skilled" : percentage >= 50 ? "Growing" : "Basic";
  const navigate=useNavigate();
  const handleCourseNavigation = (continueLearning: boolean = false) => {
    const isIntermediate = localStorage.getItem('exercise_isIntermediate') === 'true';
    const isAdvanced = localStorage.getItem('exercise_isAdvanced') === 'true';
    
    let path = '/dashboard/enrolled_course';
    if (isIntermediate) path = '/dashboard/intermediate_course';
    else if (isAdvanced) path = '/dashboard/advanced_course';

    navigate(path, continueLearning ? { state: { continueLearning: true } } : undefined);
  };

  return (
    <div className="congratulations-dialog-wrapper">
      <Dialog
        open={open}
          onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setOpen(false);
          }
        }}
        className="congratulations-dialog"
        // All original Dialog props preserved
      >
        <DialogContent
          sx={{
            position: "relative",
          }}
        >
          {!testDetails && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "rgba(255,255,255,0.35)",
                backdropFilter: "blur(2px)",
                zIndex: 10,
                borderRadius: "inherit",
              }}
            >
              <CircularProgress size={52} sx={{ color: "#4F46E5" }} />
            </div>
          )}

          <div
            className="congratulations-dialog-body"
            style={{
              pointerEvents: !testDetails ? "none" : "auto",
              opacity: !testDetails ? 0.7 : 1,
              transition: "opacity 0.2s ease",
            }}
          >
            {/* Header section */}
            <div className="personalize-icon">
              <img src={GraphIcon} alt="" />
            </div>
            <div className="personalize-dialog-title">
              Congratulations, {userName}!
            </div>
            <div className="personalize-dialog-dsc">
              Great job! Let's take a look at your performance.
            </div>

            {/* Score block - only dynamic values added */}
            <div className="overall-score-block">
              <div className="overall-score-level">
                <div className="overall-score">
                  <div className="overall-score-label">Overall Score</div>
                  <div className="overall-score-value">
                    <span className="notranslate"> {testDetails ? percentage : "--"}</span>%
                  </div>
                </div>
                <div className="proficiency-level">
                  <div className="proficiency-level-label">
                    Proficiency Level
                  </div>
                  <div className="proficiency-level-value text-center">
                    {testDetails ? proficiency : "--"}
                  </div>
                </div>
              </div>
              
              {/* Progress bar - only made dynamic */}
              <div className="overall-score-level-progress">
                <BorderLinearProgress
                  variant="determinate"
                  value={testDetails ? percentage : 0}
                  sx={{ width: "100%" }}
                />
              </div>

              <div className="correct-answers">
                <div className="answers-label">Correct Answers</div>
                <div className="answers-value">
                  {testDetails ? `${correct}/${total}` : "--/--"}
                </div>
              </div>
            </div>

            {/* Areas of focus - completely unchanged */}
            {/* <div className="areas-focus-block">
              <h4 className="areas-focus-block-title">Areas of Focus</h4>
              <div className="areas-focus-list">
                <div className="grammar">Grammar</div>
                <div className="vocabulary">Vocabulary</div>
                <div className="reading">Reading</div>
              </div>
            </div> */}

            {/* Buttons - completely unchanged */}
            <div className="congratulations-action-btn">
              <PrimaryButton
                disabled={!testDetails}
                onClick={() => handleCourseNavigation(true)}
              >
                Continue Course
              </PrimaryButton>

              <LightButton
                disabled={!testDetails}
                onClick={() => {
                  dispatch(reviewAnswer());
                  handleCourseNavigation(false);
                }}
              >
                Review Answers
              </LightButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CongratulationsDialog;